import {UserDto} from '@multipass-service-common-dto';
import {AcceptTermsAndSignInResponseDto, GetUserResponseDto, VerifyLoginCodeResponseDto} from '@multipass-user-service-dto';

export interface Session {
    readonly userId: string;
    readonly displayName: string;
    readonly email: string;
    readonly locale: string | null;
    readonly scriptPreference: string | null;
    readonly pendingDecision: string | null;
}

export class SessionMapper {
    public mapSessionFromDto(dto: VerifyLoginCodeResponseDto): Session {
        return this.#toSession(dto.user!);
    }

    public mapSessionFromUserDto(dto: GetUserResponseDto): Session {
        return this.#toSession(dto.user!);
    }

    public mapSessionFromAcceptDto(dto: AcceptTermsAndSignInResponseDto): Session {
        return this.#toSession(dto.user!);
    }

    #toSession(user: UserDto): Session {
        return {
            userId: user.userId,
            displayName: user.displayName,
            email: user.email,
            locale: user.locale ?? null,
            scriptPreference: user.scriptPreference ?? null,
            pendingDecision: user.pendingDecision ?? null,
        };
    }
}
